import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { InfographicsStackedBar, type InfographicsStackedBarProps } from './widget/InfographicsStackedBar';
import { InfographicsPieChart } from './widget/InfographicsPieChart';
import { type ChartMountOptions } from './widget/chartTheme';

export type MountOptions = ChartMountOptions;

const roots = new WeakMap<Element, Root>();

export function mount(el: Element, options: MountOptions) {
  let root = roots.get(el);
  if (!root) {
    root = createRoot(el);
    roots.set(el, root);
  }
  if (options.chartType === 'pie') {
    root.render(<InfographicsPieChart {...options} />);
    return;
  }
  root.render(<InfographicsStackedBar {...(options as InfographicsStackedBarProps)} />);
}

export function unmount(el: Element) {
  const root = roots.get(el);
  if (root) {
    root.unmount();
    roots.delete(el);
  }
}

// Optionaler Auto-Mount per data-attributes.
// <div data-ddk-infographics data-endpoint="/infographics/v1/sums"></div>
function autoMount() {
  const nodes = document.querySelectorAll<HTMLElement>('[data-ddk-infographics]');
  nodes.forEach((node) => {
    const endpoint = node.dataset.endpoint || '/infographics/v1/sums';
    const height = node.dataset.height ? Number(node.dataset.height) : undefined;
    const locale = node.dataset.locale;
    const chartType = node.dataset.chartType === 'pie' ? 'pie' : 'stacked-bar';
    mount(node, { endpoint, height, locale, chartType });
  });
}

if (typeof window !== 'undefined') {
  // @ts-expect-error - global for embedding
  window.DdkInfographics = { mount, unmount };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoMount);
  } else {
    autoMount();
  }
}

